export enum ExampleDocumentTypeEnum {
    EXAMPLE_DOCUMENTS = 'exampleDocuments',
}
